const bug = {
  namespaced: true,
  state: {
    isShowList: true,
  },
  // synchronization
  mutations: {
    setIsShowList(state, isShowList) {
      state.isShowList = isShowList;
    },
  },
  // asynchronization
  actions: {},
};
export default bug;
